var app = angular.module("leonardo");

var PortfolioListActions = function($scope, ngDialog, AccountUserService, PermissionService, AccountService, AuthDataService, $timeout) {

  $scope.permissionService = PermissionService;

  $scope.showPropertyReportDialog = function() {
    ngDialog.open({
      template: 'views/templates/dialog/portfolio/report.html',
      controller: 'PropertyReportDialog',
      className: 'ngdialog-theme-default ngdialog-task-report'
    });
  };


  $scope.showPortfolioAddDialog = function() {
    if ((AccountService.getCollection().length > 1) && AuthDataService.isNotStaff()) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/account/select.html',
        controller: 'SelectAccountDialog',
        className: 'ngdialog-theme-default ngdialog-select-account',
        data: {
          permission: 'permission_add_portfolio'
        }
      }).then(function (account) {
        $timeout(function () {
          if (account) {
            ngDialog.open({
              template: 'views/templates/dialog/portfolio/add.html',
              controller: 'PortfolioAddDialog',
              data: {
                mode: 'create',
                account: (account !== 'all') ? account : null
              }
            });
          }
        }, 200);
      }, function () {
        return;
      });
    }
    else {
      ngDialog.open({
        template: 'views/templates/dialog/portfolio/add.html',
        controller: 'PortfolioAddDialog',
        data:{
          mode: 'create',
          account: AccountUserService.currentAccountUser.account
        }
      });
    }
  };

  
  $scope.propertyAddDialog = function(){
    ngDialog.openConfirm({
      template: 'views/templates/dialog/portfolio/add-property.html',
      controller: 'AddPropertyDialog',
      className: 'ngdialog-theme-default ngdialog-template-show',
    }).then(function () {
      // This is intentional do_something blank function
    }, function () {
      return;
    });
  };


};

app.controller('PortfolioListActions', ['$scope', 'ngDialog', 'AccountUserService', 'PermissionService',
  'AccountService', 'AuthDataService', '$timeout', PortfolioListActions]);
